import { create } from 'zustand';

type State = {
  priceIndex?: number;
  logisticsList: ShippingTypes.LogisticsList[];
};

type Action = {
  setExpressType: (type: string, defaultLogisticsList: ShippingTypes.LogisticsList[]) => void;
  setPriceIndex: (i: number) => void;
  setLogistics: (l: ShippingTypes.LogisticsList[], priceIndex: number) => void;
};

const SemiStore = create<State & Action>((set) => ({
  // 运力线列表
  logisticsList: [],
  setPriceIndex: (index) => {
    set({
      priceIndex: index,
    });
  },
  // 更新物流
  setExpressType: (type, defaultLogisticsList) => {
    set((state) => {
      return {
        ...state,
        logisticsList: state.logisticsList.map((item, index) => {
          if (item.listData?.some((item) => item.type === type)) {
            return {
              ...item,
              defaultLogistics: type,
            };
          }
          return defaultLogisticsList[index];
        }),
      };
    });
  },
  setLogistics: (logisticsList, priceIndex) => {
    set({
      priceIndex,
      logisticsList: logisticsList,
    });
  },
}));

export default SemiStore;
